var map = {
	"./airdropArrow.svg": 5120,
	"./airdropBox.svg": 3388,
	"./airdropBoxInactive.svg": 1111,
	"./arrow.svg": 7933,
	"./backArrow.svg": 5622,
	"./binance.svg": 1464,
	"./bitget.svg": 6493,
	"./bitgetBackground.svg": 7025,
	"./bitgetBanner.svg": 307,
	"./bronzeMedal.svg": 6647,
	"./buy_wod.svg": 2137,
	"./check.svg": 7486,
	"./closeReward.svg": 7579,
	"./coingecko.svg": 4406,
	"./coinmarketcap.svg": 2423,
	"./cowIcon.svg": 3108,
	"./cupIcon.svg": 3121,
	"./cupIconActive.svg": 3527,
	"./custom.svg": 5507,
	"./dailySession/closeDaily.svg": 7665,
	"./discord.svg": 2338,
	"./discordCompleted.svg": 137,
	"./earnAssets/dypius.svg": 3054,
	"./earnAssets/earnArrow.svg": 4603,
	"./earnAssets/kucoin.svg": 9493,
	"./earnAssets/open_chest.svg": 7576,
	"./earnAssets/openflux.svg": 8899,
	"./earnAssets/wodToken.svg": 5463,
	"./earnAssets/world-of-dypians.svg": 1539,
	"./facebook.svg": 6338,
	"./facebookCompleted.svg": 873,
	"./friendsIcon.svg": 6722,
	"./friendsIconActive.svg": 3664,
	"./gameIcon.svg": 811,
	"./gameIconActive.svg": 5713,
	"./gifBg.svg": 8053,
	"./giftIcon.svg": 5411,
	"./giftIconActive.svg": 7065,
	"./goldMedal.svg": 1033,
	"./houseIcon.svg": 2701,
	"./houseIconActive.svg": 2779,
	"./infoTooltip.svg": 3755,
	"./instagram.svg": 1574,
	"./instagramCompleted.svg": 925,
	"./kuCoinBanner.svg": 9039,
	"./kucoin.svg": 7697,
	"./leftArrow.svg": 1996,
	"./linkedin.svg": 7464,
	"./medium.svg": 2331,
	"./nextArrow.svg": 7724,
	"./open_chest.svg": 7116,
	"./openflux.svg": 7815,
	"./pinNetworkBanner.svg": 5769,
	"./prevArrow.svg": 7924,
	"./rightArrow.svg": 8195,
	"./silverMedal.svg": 3422,
	"./syncIcon.svg": 4148,
	"./taskIcon.svg": 4746,
	"./taskIconActive.svg": 1256,
	"./tasksIcon.svg": 2303,
	"./tasksIconActive.svg": 5357,
	"./telegram.svg": 5039,
	"./telegramCompleted.svg": 14,
	"./tooltip.svg": 4643,
	"./tradingCompBg.svg": 9497,
	"./twitter.svg": 1663,
	"./twitterCompleted.svg": 3118,
	"./usdt.svg": 4222,
	"./userLeaderboardBg.svg": 3701,
	"./userLeaderboardWeeklybg.svg": 6200,
	"./verified.svg": 9126,
	"./walletIcon.svg": 6166,
	"./world-of-dypians.svg": 6887,
	"./xMark.svg": 4717,
	"./xMarkWhite.svg": 9864,
	"./youtube.svg": 8549,
	"./youtubeCompleted.svg": 6336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1980;